(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (!canHover.matches || reduceMotion.matches) return;

    document.querySelectorAll('.header__heading-link').forEach((link) => {
      const logo = link.querySelector('.header__heading-logo-wrapper');
      if (!logo) return;

      let baseScale = 1;
      let releaseTimer;

      const setBaseScale = (value) => {
        baseScale = value;
        logo.style.setProperty('--mw-base-scale', value.toFixed(4));
        if (!logo.classList.contains('mw-logo-pressed')) {
          logo.style.setProperty('--mw-scale', value.toFixed(4));
        }
      };

      const reset = () => {
        clearTimeout(releaseTimer);
        logo.classList.remove('mw-logo-pressed', 'mw-logo-release');
        logo.style.setProperty('--mw-rx', '0deg');
        logo.style.setProperty('--mw-ry', '0deg');
        logo.style.setProperty('--mw-tx', '0px');
        logo.style.setProperty('--mw-ty', '0px');
        setBaseScale(1);
      };

      link.addEventListener('pointermove', (event) => {
        const rect = logo.getBoundingClientRect();
        if (!rect.width || !rect.height) return;

        const x = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
        const y = Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height));
        const dx = x - 0.5;
        const dy = y - 0.5;
        const distance = Math.min(1, Math.sqrt(dx * dx + dy * dy) / 0.7071);
        const bubble = 1 - distance;

        logo.style.setProperty('--mw-ry', (dx * 5.6).toFixed(2) + 'deg');
        logo.style.setProperty('--mw-rx', (-dy * 3.6).toFixed(2) + 'deg');
        logo.style.setProperty('--mw-tx', (dx * 4.4).toFixed(2) + 'px');
        logo.style.setProperty('--mw-ty', (dy * 2.8).toFixed(2) + 'px');
        setBaseScale(1.018 + bubble * 0.027);
      });

      link.addEventListener('pointerdown', () => {
        clearTimeout(releaseTimer);
        logo.classList.remove('mw-logo-release');
        logo.classList.add('mw-logo-pressed');
        logo.style.setProperty('--mw-scale', (baseScale * 0.965).toFixed(4));
      });

      const release = () => {
        if (!logo.classList.contains('mw-logo-pressed')) return;
        logo.classList.remove('mw-logo-pressed');
        logo.classList.remove('mw-logo-release');
        void logo.offsetWidth;
        logo.classList.add('mw-logo-release');
        logo.style.setProperty('--mw-scale', baseScale.toFixed(4));
        releaseTimer = window.setTimeout(() => {
          logo.classList.remove('mw-logo-release');
        }, 250);
      };

      link.addEventListener('pointerup', release);
      link.addEventListener('pointercancel', release);
      link.addEventListener('pointerleave', reset);
      link.addEventListener('blur', reset, true);
    });
  })();

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
